import { Fab } from "@mui/material";
import styled from "styled-components";

const MRFab = styled(Fab)``;

export default MRFab;
